import { Injectable } from '@angular/core';

import { Loggable } from 'app/utils/logging/loggable';

/**
 * Service to observe the pressure of the system.
 * useage:
 *
    // attach listener in the component
    this.computePressureService.observePressure((state: PressureState) => {
      this.pressureState = state;
      this.handlePressureChange(state);
    });

    // create a handler
  private handlePressureChange(state: PressureState): void {
    this.pressureState = state;
    console.error(`Current pressure state: ${state}`);
    if (state === PressureState.CRITICAL) {
      // Implement logic for critical state
    } else if (state === PressureState.SERIOUS) {
      // Implement logic for serious state
    } else {
      // Implement logic for nominal or fair state
    }
  }

 */

@Injectable({
  providedIn: 'root',
})
export class ComputePressureService extends Loggable {
  public constructor() {
    super();
  }

  public observePressure(callback: (state: PressureState) => void): void {
    if ('PressureObserver' in window) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const observer = new (window as any).PressureObserver((records: PressureStateRecord[]) => {
        const lastRecord = records[records.length - 1];
        callback(lastRecord.state);
      });

      observer.observe('cpu', { sampleInterval: 1000 }).catch((error: Error) => {
        this.error('Error setting up PressureObserver:', error);
      });
    } else {
      this.warn('PressureObserver API is not supported in this browser.');
    }
  }
}

export interface PressureStateRecord {
  state: PressureState;
  timestamp: number;
}

export enum PressureState {
  NOMINAL = 'nominal',
  FAIR = 'fair',
  SERIOUS = 'serious',
  CRITICAL = 'critical',
}
